export default function Django_Tutorial() {
  return <div>Django_Tutorial Component</div>;
}
